var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskboardTags(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39083 1.72398C8.14084 1.47391 7.80176 1.33339 7.44816 1.33331H2.66683C2.31321 1.33331 1.97407 1.47379 1.72402 1.72384C1.47397 1.97389 1.3335 2.31302 1.3335 2.66665V7.44798C1.33357 7.80157 1.4741 8.14066 1.72416 8.39065L7.52683 14.1933C7.82984 14.4944 8.23966 14.6634 8.66683 14.6634C9.094 14.6634 9.50382 14.4944 9.80683 14.1933L14.1935 9.80665C14.4946 9.50364 14.6636 9.09382 14.6636 8.66665C14.6636 8.23948 14.4946 7.82966 14.1935 7.52665L8.39083 1.72398Z",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 5.33335C5.18393 5.33335 5.33317 5.18412 5.33317 5.00002C5.33317 4.81593 5.18393 4.66669 4.99984 4.66669C4.81574 4.66669 4.6665 4.81593 4.6665 5.00002C4.6665 5.18412 4.81574 5.33335 4.99984 5.33335Z",
    fill: "#828282",
    stroke: "#828282",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskboardTags);
export default __webpack_public_path__ + "static/media/taskboard_tags.5f66b9dfe211b159a9c03f1fdd9bb9b3.svg";
export { ForwardRef as ReactComponent };